import { format, parseISO } from 'date-fns'
import { fr } from 'date-fns/locale'

export const COLORS = {
    CLOSED: '#e5e7eb',
    RED: '#dc2626',
    ORANGE: '#fb923c',
    LIME: '#8fbf3f',
    GREEN: '#22c55e',
}

export const COLOR_SCALE = [
    {from: 0, to: 0, color: COLORS.CLOSED, name: 'Fermé'},
    {from: 1, to: 49, color: COLORS.RED, name: 'Ouvert 1-49%'},
    {from: 50, to: 99, color: COLORS.ORANGE, name: 'Ouvert 50-99%'},
    {from: 100, to: 100, color: COLORS.GREEN, name: 'Ouvert 100%'},
]

export const COLOR_SCALE_OVERALL = [
    {from: 0, to: 0, color: COLORS.CLOSED, name: 'Fermé'},
    {from: 1, to: 49, color: COLORS.RED, name: 'Ouvert 1-49%'},
    {from: 50, to: 89, color: COLORS.ORANGE, name: 'Ouvert 50-89%'},
    {from: 90, to: 94, color: COLORS.LIME, name: 'Ouvert 90-94%'},
    {from: 95, to: 100, color: COLORS.GREEN, name: 'Ouvert 95-100%'},
]

export const getColor = (rate) => {
    if (rate === 0) return COLORS.CLOSED
    if (rate === 100) return COLORS.GREEN
    if (rate >= 50) return COLORS.ORANGE
    return COLORS.RED
}

const isDateFormat = (date) => /^\d{4}-\d{2}-\d{2}$/.test(date)

export const getDateLabel = (day) => {
    if (!day || !day.date) return 'N/A'

    if (isDateFormat(day.date)) {
        try {
            return format(parseISO(day.date), 'EEE dd MMM', {locale: fr})
        } catch (e) {
            return day.date
        }
    }
}

export const getWeekDayLabel = (day) => {
    if (!day || !day.date) return 'N/A'

    const s = String(day.date)
    return s.charAt(0) + s.slice(1)
}
